import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, Loader2, ArrowLeft } from "lucide-react";
import { apiClient, setToken, formatErr } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await apiClient.post("/auth/login", form);
      setToken(data.access_token);
      toast.success(`Benvenuto, ${data.user.username}`);
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white border border-zinc-300 px-4 py-3.5 text-zinc-900 placeholder:text-zinc-400 focus:outline-none focus:border-[#E63946] transition-colors text-sm";
  const labelCls =
    "block text-xs uppercase tracking-[0.18em] font-mono text-zinc-500 mb-2";

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-zinc-50 px-6 py-10 relative overflow-hidden"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-60"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      />
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#E63946]/15 blur-[140px] rounded-full pointer-events-none" />

      <a
        href="/"
        className="absolute top-6 left-6 inline-flex items-center gap-2 text-zinc-500 hover:text-zinc-900 text-xs uppercase tracking-widest font-mono transition-colors"
      >
        <ArrowLeft size={14} /> Torna al sito
      </a>

      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <span className="relative inline-flex w-9 h-9 items-center justify-center bg-[#E63946]">
            <span className="font-heading font-black text-white text-lg leading-none">M</span>
            <span className="absolute -bottom-1 -right-1 w-2 h-2 bg-zinc-900"></span>
          </span>
          <span className="font-heading font-black tracking-tighter text-2xl text-zinc-900">
            Motorie<span className="text-[#E63946]">Ricambi</span>
          </span>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="relative bg-white border border-zinc-200 shadow-xl shadow-zinc-200/60 p-8"
        >
          <div className="absolute -top-px -left-px w-12 h-12 border-t-2 border-l-2 border-[#E63946]" />
          <div className="absolute -bottom-px -right-px w-12 h-12 border-b-2 border-r-2 border-[#E63946]" />

          <div className="flex items-center gap-3 mb-1">
            <div className="w-8 h-px bg-[#E63946]" />
            <span className="text-xs uppercase tracking-[0.3em] font-mono text-[#E63946]">
              Area Riservata
            </span>
          </div>
          <h1 className="font-heading font-black text-3xl tracking-tighter mb-7 text-zinc-900">
            Accesso Admin
          </h1>

          <div className="space-y-5">
            <div>
              <label className={labelCls}>Username</label>
              <input
                name="username"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                data-testid="login-username"
                autoFocus
                className={inputCls}
                placeholder="admin"
              />
            </div>
            <div>
              <label className={labelCls}>Password</label>
              <input
                name="password"
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                data-testid="login-password"
                className={inputCls}
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full inline-flex items-center justify-center gap-3 px-6 py-4 bg-[#E63946] hover:bg-[#c81d25] disabled:opacity-60 text-white font-bold uppercase tracking-widest text-sm transition-colors"
            >
              {loading ? (
                <Loader2 size={18} className="animate-spin" />
              ) : (
                <LogIn size={16} />
              )}
              {loading ? "Verifica..." : "Accedi"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
